import { FILE_TYPES } from '../../../formFileTypesEnum';
import { VENDORS } from '../../../formQuestionsEnum';

export const THIRD_PARTY_SERVICES_FIELDS = [
  {
    question: VENDORS.HOSPICE_VENDOR,
    title: 'Hospice',
    invoiceFileTypeId: FILE_TYPES.HOSPICE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.HOSPICE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.PODIATRY_VENDOR,
    title: 'Podiatry',
    invoiceFileTypeId: FILE_TYPES.PODIATRY_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.PODIATRY_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.DENTAL_VENDOR,
    title: 'Dental',
    invoiceFileTypeId: FILE_TYPES.DENTAL_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.DENTAL_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.BEAUTY_AND_BARBER_VENDOR,
    title: 'Beauty and barber',
    invoiceFileTypeId: FILE_TYPES.BEAUTY_AND_BARBER_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.BEAUTY_AND_BARBER_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.EYE_DOCTOR_VENDOR,
    title: 'Eye doctor',
    invoiceFileTypeId: FILE_TYPES.EYE_DOCTOR_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.EYE_DOCTOR_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.EDUCATION_VENDOR,
    title: 'Education',
    invoiceFileTypeId: FILE_TYPES.EDUCATION_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.EDUCATION_VENDOR_CONTRACT,
  },
];
